const MessageEdited = () => (
  <span className="text-sm italic text-neutral-400 dark:text-neutral-500 ml-1">
    (edited)
  </span>
)

export default MessageEdited
